import { render, staticRenderFns } from "./RenovacionComponent.vue?vue&type=template&id=066c4d92&scoped=true"
import script from "./RenovacionComponent.vue?vue&type=script&lang=js"
export * from "./RenovacionComponent.vue?vue&type=script&lang=js"
import style0 from "./RenovacionComponent.vue?vue&type=style&index=0&id=066c4d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066c4d92",
  null
  
)

export default component.exports